import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=5ffd6905&scoped=true"
import script from "./UploadVideo.vue?vue&type=script&lang=js"
export * from "./UploadVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=5ffd6905&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd6905",
  null
  
)

export default component.exports